/**
 * Global Scroll-Reveal Animation System
 * -------------------------------------
 * One reusable IntersectionObserver-driven reveal system for the whole theme.
 * Elements opt in with a `data-scroll-reveal` attribute (optionally
 * "left" | "right" | "scale" | "image-scale"). Each element animates once.
 * Respects prefers-reduced-motion (handled primarily in CSS; this script
 * also skips observing entirely when reduced motion is requested).
 */
(function () {
  var reduceMotionQuery =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAllImmediately(elements) {
    elements.forEach(function (element) {
      element.classList.add('is-scroll-revealed');
    });
  }

  function initScrollReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll('[data-scroll-reveal]:not(.is-scroll-revealed)');

    if (!elements.length) return;

    if (reduceMotionQuery && reduceMotionQuery.matches) {
      revealAllImmediately(elements);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      revealAllImmediately(elements);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-scroll-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -80px 0px',
      }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function boot() {
    initScrollReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-scan when Shopify sections load/re-render in the theme editor,
     and when new content is injected (e.g. infinite scroll, quick add). */
  document.addEventListener('shopify:section:load', function (event) {
    initScrollReveal(event.target || document);
  });

  window.ThemeScrollReveal = { init: initScrollReveal };
})();
